import Landing from "../Models/LandingModels/Landing";

export const getCaptainNationalIdDigits = (value?: string | null) => (value || '').replace(/\D/g, '');

export const isCaptainNationalIdValid = (value?: string | null) => getCaptainNationalIdDigits(value).length === 10;

// Flokkar útgerðar sem þurfa ekki upplýsingar um skipstjóra.
export const CAPTAIN_INFO_EXEMPT_OPERATION_CATEGORY_IDS = [
  -14, // Öflun sjávargróðurs.
  -11, // Frístundaveiðar án aflaheimilda.
];

export const hasCaptainInfo = (landing?: Landing | null) => {
  return Boolean(landing?.captainName?.trim() && landing?.captainNationalId?.trim());
};

export const isForeignShipLanding = (landing?: Landing | null) => {
  return Boolean(landing?.ship?.isForeign);
};

// Athugar hvort flokkur útgerðar skips sé undanþeginn kröfu um skipstjóra.
export const hasCaptainInfoExemptOperationCategory = (landing?: Landing | null) => {
  const operationCategory = landing?.ship?.operationCategory;
  return operationCategory !== undefined &&
    operationCategory !== null &&
    CAPTAIN_INFO_EXEMPT_OPERATION_CATEGORY_IDS.includes(operationCategory);
};

export const formatCaptainNationalId = (value?: string | null) => {
  const digits = getCaptainNationalIdDigits(value).slice(0, 10);
  if (digits.length <= 6) {
    return digits;
  }

  return `${digits.slice(0, 6)}-${digits.slice(6)}`;
};

export const isCaptainInfoMissing = (landing?: Landing | null) => {
  if (!landing?.id || isForeignShipLanding(landing) || hasCaptainInfoExemptOperationCategory(landing)) {
    return false;
  }

  return !hasCaptainInfo(landing);
};
